// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"7ed924b9","563":"028328df","694":"e16aeaea"}[chunkId] + ".chunk.css";
};